/** Convierte fraccional 'a/b' o 'X' a decimal europeo (a/b)+1. Devuelve null si inválido. */
export function fractionalToDecimal(txt) {
    if (txt == null) return null;
    const s = String(txt).trim();
    if (!s) return null;
    // Descartar casos especiales bet365
    if (/^sp$/i.test(s)) return null;
    if (/^even(s)?$/i.test(s)) return 2.0;
    const m = s.match(/^\s*(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)\s*$/);
    if (m) {
        const a = parseFloat(m[1]);
        const b = parseFloat(m[2]);
        if (!isFinite(a) || !isFinite(b) || b <= 0) return null;
        return a / b + 1;
    }
    const n = parseFloat(s);
    if (isFinite(n)) {
        // Podría venir ya como decimal (ej 3.5) o como entero (3 = 3/1 = 4.0)
        if (n >= 1.01 && n <= 1000.0) return n;
        // Si es <1 no válido; si es entero pequeño interpretamos como X/1 sumando 1
        if (n > 0 && n < 1.01) return null;
        return n + 1;
    }
    return null;
}

export function isValidDecimalOdds(x) {
    return typeof x === "number" && isFinite(x) && x >= 1.01 && x <= 1000.0;
}

export function fmtOdds(x, digits = 2) {
    if (x == null || !isFinite(Number(x))) return "—";
    return Number(x).toFixed(digits);
}

export function impliedProbFromDecimal(x) {
    if (!isValidDecimalOdds(Number(x))) return null;
    return 1.0 / Number(x);
}
